const css = `.lO1m4G__container{margin:auto}.lO1m4G__tableContainer{min-height:630px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tableContainer":"lO1m4G__tableContainer","container":"lO1m4G__container"};
